<template>
  <div class="form-notin-premium" :class="{ 'form-en-plantilla': enPlantilla }" id="contact" :style="containerStyle">
    <v-container>
      <v-row class="form-row-premium">
        <!-- Col 1: Form -->
        <v-col lg="7" md="12" sm="12" cols="12" :order="control.ImagenPosicion === 1 ? 2 : 1">
          <div class="form-container-premium" :style="cardStyle">
            <div class="mb--40 titulo-form-notin" :style="{ textAlign: control.Titulo.css.Align }">
              <h2 class="heading-title" :style="tituloInlineStyle" v-html="control.Titulo.Texto"></h2>
              <p class="description" :style="descripcionInlineStyle" v-html="control.Descripcion.Texto">
              </p>
            </div>

            <div class="form-wrapper-premium">
              <form v-if="!enviado" @submit.prevent="handleSubmit">
                <v-row>
                  <!-- Name -->
                  <v-col cols="12" sm="6" v-if="control.Fields.Name">
                    <div class="form-group-premium">
                      <input 
                        type="text" 
                        v-model="form.name" 
                        :placeholder="$t('nombre') + (control.Fields.ForceName ? ' *' : '')"
                        :style="inputStyle"
                      />
                      <span class="input-error" v-if="errors.name">{{ errors.name }}</span>
                    </div>
                  </v-col>

                  <!-- Email -->
                  <v-col cols="12" sm="6" v-if="control.Fields.Email">
                    <div class="form-group-premium">
                      <input 
                        type="email" 
                        v-model="form.email" 
                        :placeholder="$t('email') + (control.Fields.ForceEmail ? ' *' : '')"
                        :style="inputStyle"
                      />
                      <span class="input-error" v-if="errors.email">{{ errors.email }}</span>
                    </div>
                  </v-col>

                  <!-- Phone -->
                  <v-col cols="12" sm="6" v-if="control.Fields.Phone">
                    <div class="form-group-premium">
                      <input 
                        type="text" 
                        v-model="form.phone" 
                        :placeholder="$t('telefono') + (control.Fields.ForcePhone ? ' *' : '')"
                        :style="inputStyle"
                      />
                      <span class="input-error" v-if="errors.phone">{{ errors.phone }}</span>
                    </div>
                  </v-col>

                  <!-- Subject -->
                  <v-col cols="12" sm="6" v-if="control.Fields.Subject">
                    <div class="form-group-premium">
                      <input 
                        type="text" 
                        v-model="form.subject" 
                        :placeholder="$t('asunto') + (control.Fields.ForceSubject ? ' *' : '')"
                        :style="inputStyle"
                      />
                      <span class="input-error" v-if="errors.subject">{{ errors.subject }}</span>
                    </div>
                  </v-col>

                  <!-- Message -->
                  <v-col cols="12" v-if="control.Fields.Message">
                    <div class="form-group-premium">
                      <textarea 
                        v-model="form.message" 
                        :placeholder="$t('mensaje') + (control.Fields.ForceMessage ? ' *' : '')"
                        :style="inputStyle"
                      ></textarea>
                      <span class="input-error" v-if="errors.message">{{ errors.message }}</span>
                    </div>
                  </v-col>
                </v-row>

                <!-- Compliance -->
                <div class="check-pd-premium mb--30">
                  <input type="checkbox" v-model="checkboxpd" id="pd-premium" />
                  <label for="pd-premium" :style="textStyle">
                    {{ $t('aceptoDatos') }}
                    <NuxtLink :to="'/protecciondatos'" :style="{ color: estiloTituloColor }">{{ $t('aqui') }}</NuxtLink>
                  </label>
                  <div class="input-error" v-if="errors.pd" style="display: block; margin-top: 5px;">{{ errors.pd }}</div>
                </div>

                <!-- Submit Button -->
                <v-btn 
                  class="btn-submit-premium" 
                  @click="handleSubmit"
                  :loading="sending"
                  :style="buttonStyle"
                  elevation="0"
                >
                  {{ control.Button.Texto }}
                </v-btn>
              </form>

              <div v-if="enviado" class="success-message-modern">
                <div class="success-icon-container">
                  <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                    <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                    <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                  </svg>
                </div>
                <h3 class="success-title">{{ $t('emailSuccessTitle') }}</h3>
                <p class="success-text">{{ $t('emailEnviado') }}</p>
                <p class="success-subtext">{{ $t('emailSuccessSubtext') }}</p>
                <SolicitudAdelantarTramite />
              </div>
              <div v-if="enviado === false" class="error-message-modern">
                <v-icon color="error" size="32" class="mb-2">mdi-alert-circle-outline</v-icon>
                <div v-if="store.NOTARIA?.Contacto?.Email">
                  <p class="mb-0">{{ $t('emailErrorWriteTo') }}
                    <a :href="'mailto:' + store.NOTARIA.Contacto.Email" class="error-inline-link">
                      {{ store.NOTARIA.Contacto.Email }}
                    </a>
                  </p>
                </div>
                <div v-else-if="store.NOTARIA?.Contacto?.Telefono">
                  <p class="mb-0">{{ $t('emailErrorCallTo') }}
                    <a :href="'tel:' + store.NOTARIA.Contacto.Telefono" class="error-inline-link">
                      {{ store.NOTARIA.Contacto.Telefono }}
                    </a>
                  </p>
                </div>
                <p v-else class="mb-0">{{ $t('emailError') }}</p>
              </div>
              <div v-if="lockEmail" class="error-message-modern">
                <v-icon color="error" size="32" class="mb-2">mdi-lock-clock</v-icon>
                <p>{{ $t('lockEmail') }}</p>
              </div>
            </div>
          </div>
        </v-col>

        <!-- Col 2: Image -->
        <v-col lg="5" md="12" sm="12" cols="12" :order="control.ImagenPosicion === 1 ? 1 : 2">
          <div class="form-image-container">
            <img 
              :src="control.Imagen ? imagenIDtoSRC(control.Imagen) : '/images/about/about-6.jpg'" 
              alt="Contacto"
            />
            <div class="image-overlay"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, toRaw } from 'vue'
import { useEstiloFormulario } from '../../composables/estiloFormulario'
import nuxtStorage from 'nuxt-storage';
import { useStore } from '../../store/index'
import { storeToRefs } from 'pinia'
import { useUtils } from '#imports';
import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3';

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t } = useUtils()
const { vueApp } = useNuxtApp();
const route = useRoute();

const props = defineProps({
  contactForm: {
    type: Object,
    required: true
  }
})

// Sigue a props.contactForm (antes era una copia fija y no reflejaba los cambios)
const control = computed(() => props.contactForm)
const actionName = 'email'
const sending = ref(false)
const enviado = ref(null)
const lockEmail = ref(null)
const checkboxpd = ref(false)
const form = ref({
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
  recaptcha: {
    id_credential: store.NOTARIA.Personalizar.RecaptchaGroup,
    token: "",
    action: actionName
  }
})
const errors = ref({ name: "", email: "", phone: "", subject: "", message: "", pd: "" })

// Style computations to respect Admin Panel settings (en las plantillas 2 a 5, los de la plantilla)
const containerStyle = computed(() => ({
  color: estilo.value.titulo.color
}))

const cardStyle = computed(() => enPlantilla.value
  ? { backgroundColor: 'var(--n2-superficie)', borderColor: 'var(--n2-borde)', color: 'var(--n2-texto)' }
  : {
    backgroundColor: `${control.value.Titulo.css.Color}0D`, // 5% opacity of text color
    borderColor: `${control.value.Titulo.css.Color}33`, // 20% opacity
    color: control.value.Titulo.css.Color
  })

const inputStyle = computed(() => enPlantilla.value
  ? { color: 'var(--n2-texto)', borderColor: 'var(--n2-borde)', borderWidth: '1px', borderStyle: 'solid', backgroundColor: 'var(--n2-superficie)', fontFamily: 'var(--n2-fuente-texto)' }
  : {
    color: control.value.Titulo.css.Color,
    borderColor: control.value.Button.css.BackgroundColor, // Usar color del botón
    borderWidth: '2px',
    borderStyle: 'solid',
    backgroundColor: '#ffffff', // Fondo blanco para mayor claridad
    fontFamily: control.value.Titulo.css.Font
  })

const textStyle = computed(() => ({
  color: estilo.value.titulo.color,
  fontFamily: estilo.value.descripcion.fuente
}))

const buttonStyle = computed(() => ({
  backgroundColor: estilo.value.boton.fondo,
  color: estilo.value.boton.color,
  fontFamily: estilo.value.boton.fuente,
  fontSize: estilo.value.boton.tamano,
  fontWeight: estilo.value.boton.peso
}))

const barAlignment = computed(() => {
  const align = control.value.Titulo.css.Align;
  if (align === 'center') return { left: '50%', transform: 'translateX(-50%)', right: 'auto' };
  if (align === 'right') return { left: 'auto', transform: 'none', right: '0' };
  return { left: '0', transform: 'none', right: 'auto' };
})

// Estilo del panel o, en las plantillas 2 a 5, el de la plantilla (ref: https://trello.com/c/LccFAOAR)
const { enPlantilla, estilo } = useEstiloFormulario(() => props.contactForm)
const estiloTituloColor = computed(() => estilo.value.titulo.color)
const estiloTituloBackgroundColor = computed(() => estilo.value.titulo.fondo)
const estiloTituloFont = computed(() => estilo.value.titulo.fuente)
const estiloTituloSize = computed(() => estilo.value.titulo.tamano)
const estiloTituloWeight = computed(() => estilo.value.titulo.peso)
const estiloTituloAlign = computed(() => estilo.value.titulo.alinear)

const estiloDescripcionColor = computed(() => estilo.value.descripcion.color)
const estiloDescripcionBackgroundColor = computed(() => estilo.value.descripcion.fondo)
const estiloDescripcionFont = computed(() => estilo.value.descripcion.fuente)
const estiloDescripcionSize = computed(() => estilo.value.descripcion.tamano)
const estiloDescripcionWeight = computed(() => estilo.value.descripcion.peso)
const estiloDescripcionAlign = computed(() => estilo.value.descripcion.alinear)

const estiloButtonColor = computed(() => estilo.value.boton.color)
const estiloButtonBackgroundColor = computed(() => estilo.value.boton.fondo)
const estiloButtonFont = computed(() => estilo.value.boton.fuente)
const estiloButtonSize = computed(() => estilo.value.boton.tamano)
const estiloButtonWeight = computed(() => estilo.value.boton.peso)
const estiloButtonAlign = computed(() => estilo.value.boton.alinear)
const borderButton = computed(() => enPlantilla.value ? 'none' : (control.value.Button.css.Color ?? "2px solid" + control.value.Button.css.Color))

const tituloInlineStyle = computed(() => ({
  color: estilo.value.titulo.color,
  fontFamily: estilo.value.titulo.fuente,
  fontSize: estilo.value.titulo.tamano,
  fontWeight: estilo.value.titulo.peso,
  textAlign: estilo.value.titulo.alinear,
  textShadow: '2px 2px 4px ' + estilo.value.titulo.fondo
}))

const descripcionInlineStyle = computed(() => ({
  color: estilo.value.descripcion.color,
  fontFamily: estilo.value.descripcion.fuente,
  fontSize: estilo.value.descripcion.tamano,
  fontWeight: estilo.value.descripcion.peso,
  textAlign: estilo.value.descripcion.alinear
}))

// Recaptcha initialization
vueApp.use(VueReCaptcha, {
  siteKey: store.recaptchaSiteKey,
  loaderOptions: { autoHideBadge: false },
});

onMounted(async () => {
  const lastEnviado = nuxtStorage.localStorage.getData('enviado')
  if (lastEnviado != null) {
    const diferencia = (new Date()).getTime() - lastEnviado
    if (diferencia < 1 * 60 * 1000) { // 1 minute lock
      enviado.value = true
      lockEmail.value = true
    }
  }

  const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();
  await recaptchaLoaded();
  form.value.recaptcha.token = await executeRecaptcha(actionName);
})

async function handleSubmit(e?: Event) {
  if (e) e.preventDefault();
  if (lockEmail.value) return;
  
  sending.value = true;
  if (checkForm()) {
    try {
      const result = await sendMail(form.value);
      enviado.value = result == "" ? true : false;
      if (enviado.value) {
        nuxtStorage.localStorage.setData('enviado', (new Date()).getTime());
        resetForm();
      } else {
        const { executeRecaptcha } = useReCaptcha();
        form.value.recaptcha.token = await executeRecaptcha(actionName);
      }
    } catch (err) {
      enviado.value = false;
    }
  }
  sending.value = false;
}

function resetForm() {
  form.value = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    recaptcha: {
      id_credential: store.NOTARIA.Personalizar.RecaptchaGroup,
      token: "",
      action: actionName
    }
  }
}

function checkForm() {
  errors.value = { name: "", email: "", phone: "", subject: "", message: "", pd: "" }
  let valid = true
  
  if (control.value.Fields.Name && control.value.Fields.ForceName && !form.value.name) {
    errors.value.name = $t('errorNombre');
    valid = false;
  }
  if (control.value.Fields.Email) {
    if (control.value.Fields.ForceEmail && (!form.value.email || form.value.email.length < 5)) {
      errors.value.email = $t('errorEmailReq');
      valid = false;
    } else if (form.value.email && !validEmail(form.value.email)) {
      errors.value.email = $t('errorEmailValido');
      valid = false;
    }
  }
  if (control.value.Fields.Phone && control.value.Fields.ForcePhone && !form.value.phone) {
    errors.value.phone = $t('errorTelefono');
    valid = false;
  }
  if (control.value.Fields.Subject && control.value.Fields.ForceSubject && !form.value.subject) {
    errors.value.subject = $t('errorAsunto');
    valid = false;
  }
  if (control.value.Fields.Message && control.value.Fields.ForceMessage && !form.value.message) {
    errors.value.message = $t('errorMensaje');
    valid = false;
  }
  if (!checkboxpd.value) {
    errors.value.pd = $t('errorPd');
    valid = false;
  }
  return valid;
}

function validEmail(email: string) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

async function sendMail(formData: any) {
  const cuerpo = `
    Mensaje enviado desde la web: ${location.origin}<br><br>
    <b>ATENCIÓN:</b> Haga click sobre la dirección de correo de contacto para responder al remitente.<br><br>
    ${formData.name ? `Remitente: ${formData.name}<br><br>` : ''}
    ${formData.email ? `Correo de contacto: <a href="mailto:${formData.email}">${formData.email}</a><br><br>` : ''}
    ${formData.phone ? `Teléfono: ${formData.phone}<br><br>` : ''}
    ${formData.subject ? `Asunto: ${formData.subject}<br><br>` : ''}
    ${formData.message ? `Mensaje: ${formData.message}<br><br>` : ''}
    <br><br><b>Por favor, no responda a este correo. Este mensaje ha sido generado automáticamente.</b>
  `;

  let originSuffix = "FORM";
  if (route && route.path === "/") originSuffix = "FORM_INICIO";
  else if (route && route.path.includes("contacto")) originSuffix = "FORM_CONTACTO";

  const mailSubject = `Contacto WEB - ${store.NOTARIA.Nombre} - ${formData.name} - ${formData.subject || 'Consulta'} - ${originSuffix}`;

  const model = {
    perfil: "info_recaptcha_web_notaria",
    cuerpo: cuerpo,
    is_cuerpo_html: true,
    asunto: mailSubject,
    destinatarios: [{ nombre: store.NOTARIA.Nombre, direccion: store.NOTARIA.Contacto.Email }],
    destinatarios_cco: [
      { nombre: "webNotin", direccion: "web@notin.net" },
      { nombre: "avisosUnidata", direccion: "pwavisos@unidata.es" }
    ],
    recaptcha: formData.recaptcha,
    data: {
      id_notaria: store.NOTARIA.id,
      Fecha: new Date().toISOString(),
      Name: formData.name,
      Email: formData.email,
      Phone: formData.phone,
      Subject: mailSubject,
      Message: formData.message
    }
  }
  const mail_service = 'https://mailing.notin.es/api/email';

  // Save to the database inbox FIRST (fire and forget, ignore errors so it doesn't break user flow)
  try {
    let emailModel = {
      Subject: mailSubject,
      Name: form.value.name,
      Email: form.value.email,
      Phone: form.value.phone,
      Message: form.value.message
    }
    const notariaId = store.NOTARIA?.id || store.NOTARIA?.IdValue;
    const apiBase = (store.backend_api_url || (process.env.NODE_ENV === 'development' ? store.api_url : 'https://controlpanel.notin.es/')).replace(/\/+$/, '');
    const backendUrl = `${apiBase}/api/Emails/Public/${notariaId}`;
    let bodystr = btoa(unescape(encodeURIComponent(JSON.stringify(emailModel))));
    $fetch(backendUrl, { method: "POST", body: { bodystr: bodystr } }).catch(e => console.warn("No se pudo registrar copia del formulario en el panel:", e));
  } catch (e) {
    console.error("Error saving email to inbox", e);
  }

  try {
    let res: any = await $fetch(mail_service, { method: "POST", body: model, headers: { 'Content-Type': 'application/json' } });

    return res;
  } catch (e) {
    console.error("Error de envío de formulario: problema de reCAPTCHA", e);
    return "error";
  }
}
</script>

<style lang="scss" scoped>
.form-notin-premium {
  padding: 80px 0;
  background-size: cover;
  background-position: center;
}

.form-row-premium {
  align-items: stretch;
}

.form-container-premium {
  padding: 50px;
  border-radius: 24px;
  border: 1px solid;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.form-group-premium {
  margin-bottom: 25px;
  position: relative;

  input, textarea {
    width: 100%;
    padding: 15px 20px;
    border: 1px solid;
    border-radius: 12px;
    outline: none;
    transition: all 0.3s ease;
    font-size: 16px;

    &:focus {
      box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.05);
      transform: translateY(-2px);
    }
  }

  textarea {
    min-height: 150px;
    resize: none;
  }
}

.input-error {
  color: #ff5252;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

.check-pd-premium {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  
  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    margin-top: 2px;
    cursor: pointer;
  }

  label {
    font-size: 14px;
    line-height: 1.4;
    cursor: pointer;
    
    a {
      text-decoration: underline;
      font-weight: 600;
    }
  }
}

.btn-submit-premium {
  width: 100%;
  height: 56px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-3px) !important;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
  }
}

.form-image-container {
  height: 100%;
  min-height: 400px;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 100%);
  }
}

.success-message-modern {
  text-align: center;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  animation: fadeIn 0.5s ease-out;
  border: 1px solid v-bind(estiloButtonBackgroundColor);
}

.error-message-modern {
  text-align: center;
  padding: 30px 20px;
  background: rgba(255, 235, 238, 0.9);
  border-radius: 16px;
  border: 1px solid rgba(244, 67, 54, 0.2);
  color: #d32f2f;
  animation: fadeIn 0.5s ease-out;
  margin-top: 20px;
}

.error-inline-link {
  color: inherit !important;
  text-decoration: underline !important;
  font-weight: bold;
  transition: opacity 0.2s ease;
}

.error-inline-link:hover {
  opacity: 0.8;
}

.success-icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: v-bind(estiloButtonBackgroundColor);
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 0 auto;
  box-shadow: inset 0px 0px 0px v-bind(estiloButtonBackgroundColor);
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% { stroke-dashoffset: 0; }
}
@keyframes scale {
  0%, 100% { transform: none; }
  50% { transform: scale3d(1.1, 1.1, 1); }
}
@keyframes fill {
  100% { box-shadow: inset 0px 0px 0px 50px v-bind(estiloButtonBackgroundColor); }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.success-title {
  font-size: 24px;
  font-weight: v-bind(estiloTituloWeight);
  color: v-bind(estiloTituloColor);
  font-family: v-bind(estiloTituloFont);
  margin-bottom: 10px;
}

.success-text {
  font-size: 16px;
  color: v-bind(estiloDescripcionColor);
  font-family: v-bind(estiloDescripcionFont);
  font-weight: 600;
  margin-bottom: 5px;
}

.success-subtext {
  font-size: 14px;
  color: v-bind(estiloDescripcionColor);
  font-family: v-bind(estiloDescripcionFont);
  opacity: 0.8;
}

.titulo-form-notin {
  text-align: v-bind(estiloTituloAlign) !important;
  position: relative;
}

.heading-title {
  color: v-bind(estiloTituloColor) !important;
  font-family: v-bind(estiloTituloFont) !important;
  font-size: v-bind(estiloTituloSize) !important;
  font-weight: v-bind(estiloTituloWeight) !important;
  text-align: v-bind(estiloTituloAlign) !important;
  text-shadow: 2px 2px 4px v-bind(estiloTituloBackgroundColor) !important;
  display: block;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    display: none; // Remove the old classic bar
  }
}

.description {
  color: v-bind(estiloDescripcionColor) !important;
  font-family: v-bind(estiloDescripcionFont) !important;
  font-size: v-bind(estiloDescripcionSize) !important;
  font-weight: v-bind(estiloDescripcionWeight) !important;
  text-align: v-bind(estiloDescripcionAlign) !important;
  display: block;
  width: 100%;
  opacity: 0.8;
}

@media (max-width: 960px) {
  .form-container-premium {
    padding: 30px;
  }
  .form-image-container {
    display: none;
  }
}
</style>
